import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import { checkField } from '../services/authService';
import { toast } from 'react-toastify';
import { passwordRegex } from '../validation/validation'
import * as actions from '../store/actions/auth';
import image from "../components/Loader/image/loader.gif"


class SignUpForm extends React.Component {
    constructor() {
        super();
        this.state = {
            username: '',
            email: '',
            isLoader:false,
        }
    }
    refreshPage = () => {
        window.location.reload(false);
    }
   
    handleSubmit = async (values) => {
        this.setState ({
            username: '',
            email: '',
            isLoader:true,
        })
        const res = await this.props.onAuth(values.username, values.email, values.password1, values.password2)
        this.setState({
            username: res.username ? res.username[0] :'',
            email: res.email ? res.email[0] :     '',
            isLoader:false,    })
        console.log(res)
        if (res.status) {
            
            this.props.history.push('/login');
            toast.success("Congrats! You've successfully signup. Go ahead and login to activate your account")
           
        }
       
        
        
    };

    render() {
        const initialValues = {
            username: '',
            email: '',
            password1: '',
            password2: '',
        }
        const signUpSchema = Yup.object().shape({
            username: Yup.string()
                .required('Please input your username!'),
           email: Yup.string()
                .required('Please input your email!')
                .email('Invalid email')
                .test('unique email', 'This email is already exist',async (value) => {
                    let error
                    await checkField(value).then((res)=>{
            
                        if(res.data.exists===true){
                           error=false
                        }
                        else if(res.data.exists===false){
                          error=true
                       }
                        //console.log(error)
                    }).catch((err)=>{
                        //console.log(err)
                        
                    })
                    return error
                    
                  }),
                  
            password1: Yup.string()
                .required('Please input your password1!')
                .matches(passwordRegex, "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                ),
            password2: Yup.string()
                .required('Please input your password2!')
                .oneOf([Yup.ref('password1'), null], 'Password1 do not match'),
        });
        
        return (
            <div className='vh-70'>
                 <div className='container p-4'>
                <div className='box-3 p-2 mt-2 mb-2'>
                <Formik
                    initialValues={initialValues}
                    onSubmit={this.handleSubmit}
                    
                    validationSchema={signUpSchema}
                >
                    {({  touched, errors,isSubmitting, }) => (
                        <Form>
                            <div className="row">
                                {this.props.loading && <LoadingOutlined /> ||
                                    <>
                                    <div className="col-md-8">
                                    <span className=""style={{fontSize:25}}>Sign up </span>
                                    </div>
                                    <hr></hr>
                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Username:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="text" name="username" />
                                                <ErrorMessage name="username" className="text-danger" component="div" />
                                                {this.state.username && <div className="text-danger">{this.state.username}</div>}
                                            </div>
                                        </div>

                                       <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Email:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" type="text" name="email"
                                                   />
                                                <ErrorMessage name="email" className="text-danger" component="div" />
                                                {this.state.email && <div className="text-danger">{this.state.email}</div>}
                                               
                                               
                                        </div>
                                        </div>

                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Password:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" placeholder="Enter your password" type="password" name="password1" />
                                                <ErrorMessage name="password1" className="text-danger" component="div" />
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <label className="col-md-2 mt-2">
                                                Confirm your Password:
                                           </label>
                                            <div className="col-md-10">
                                                <Field className="form-control" placeholder="Confirm your password" type="password" name="password2" />
                                                <ErrorMessage name="password2" className="text-danger" component="div" />
                                            </div>
                                        </div>

                                        <div className="col-md-8">
                                            <div className="col-md-10 pt-3">
                                                <button type="submit" className=" w-100 btn btn-primary mr-2" disabled={isSubmitting}>
                                                    Submit
                                            </button>
                                            <div className='ml-1'>
                                            <div className='ml-7'>
                                           or
                                            </div>
                                            
                                            <div> <NavLink className="ml-3" to='/login'><h7 className="">Go back to Login</h7></NavLink></div>
                                            </div>
                                           
                                           
                                            <div className="form-group api-response"></div>
                                            </div>
                                        </div>
                                        { this.state.isLoader &&
                                         <div className="text-center">
                                            <div className="mt-3">
                                            <img className="w-50"src={image}></img>
                                            </div>
                                       
                                     </div>
                                    }
                                    </>
                                }
                            </div>
                        </Form>
                    )}
                </Formik>

            </div>
            </div>
            </div>
           
            
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        error: state.error
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (username, email, password1, password2) => dispatch(actions.authSignup(username, email, password1, password2))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);